import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { globalStyles } from "config/pdfStyles";
import { dateFormat, getAge, userFullName } from "helpers/common";
import moment from "moment";
import GuardianDetailRowPdf from "./GuardianDetailRowPdf";

const styles = StyleSheet.create({
  tableRow: {
    ...globalStyles.tableRow,
    paddingVertical: "10px"
  },
  guardianDetailRow: {
    paddingVertical: "5px"
  }
})

export const ClientDetailsPdf = ({ data }) => {
  const clientType = data?.client_detail?.client_type;
  const therapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;

  return (
    <View style={{ backgroundColor: "#f9f9f9", padding: "5px 10px" }}>
      <View style={globalStyles.table}>

        <View style={styles.tableRow}>
          <Text style={globalStyles.tableHead}>Last Name</Text>
          <Text style={globalStyles.tableColumn}>{data?.lastname}</Text>

          <Text style={globalStyles.tableHead}>First Name</Text>
          <Text style={globalStyles.tableColumn}>{data?.firstname}</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={globalStyles.tableHead}>Date of Birth:</Text>
          <Text style={globalStyles.tableColumn}>{dateFormat(data?.client_detail?.dob)}</Text>

          <Text style={globalStyles.tableHead}>Age:</Text>
          <Text style={globalStyles.tableColumn}>{getAge(data?.client_detail?.dob)}</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={globalStyles.tableHead}>Report Date:</Text>
          <Text style={globalStyles.tableColumn}>{dateFormat(moment())}</Text>

          <Text style={globalStyles.tableHead}>Clinician Name:</Text>
          <Text style={globalStyles.tableColumn}>{userFullName(therapist)}</Text>
        </View>

        {
          clientType == "school" ? (
            <View style={styles.tableRow}>
              <Text style={globalStyles.tableHead}>School Name:</Text>
              <Text style={globalStyles.tableColumn}>{data?.client_detail?.client_school_detail?.client_school?.name}</Text>

              <Text style={globalStyles.tableHead}>City/Town:</Text>
              <Text style={globalStyles.tableColumn}>{data?.client_detail?.city_town}</Text>
            </View>
          ) :
            (
              <View style={styles.tableRow}>
                <Text style={globalStyles.tableHead}>City/Town:</Text>
                <Text style={globalStyles.tableColumn}>{data?.client_detail?.city_town}</Text>
              </View>
            )}

        {/* Guardian Details */}
        {data?.client_detail?.client_guardian_mapping?.length > 0 &&
          data?.client_detail?.client_guardian_mapping?.map(
            (guardian, index) => {
              const slug = guardian?.client_guardian?.client_role?.slug;
              if (slug !== (clientType == "school" ? "teacher" : "parent")) {
                return null;
              }

              return (
                <GuardianDetailRowPdf
                  index={index}
                  guardian={guardian}
                  slug={slug}
                  styles={styles}
                />
              );
            }
        )}

        {/* <View style={styles.tableRow}>
          <Text style={globalStyles.tableHead}>Assessment Dates:</Text>
          <Text style={globalStyles.tableColumn}>16/07/2024, 18/07/2024</Text>
        </View> */}
      </View>
    </View>
  )
}